import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router';
import { Button, OTPInput } from 'ui';
import { addNotification } from 'notifications';
import { getApiErrorMessage } from 'utils/getApiErrorMessage';
import { getPersonalDataBrowserKey } from 'utils/personalDataBrowserKey';
import { OTP_CODE_LENGTH } from 'constants/otp';

import {
  useResendPersonalDataOtp,
  useVerifyPersonalDataOtp,
} from 'hooks/usePersonalDataChange';

import classes from './PersonalDataPages.module.scss';

export const PersonalDataOtpPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const requestId = Number(searchParams.get('request_id') || 0);
  const navigate = useNavigate();
  const [code, setCode] = useState('');
  const browserKey = getPersonalDataBrowserKey();

  const verify = useVerifyPersonalDataOtp();
  const resend = useResendPersonalDataOtp();

  const handleVerify = () => {
    if (!requestId || code.length < OTP_CODE_LENGTH) return;
    verify.mutate(
      { request_id: requestId, code, browser_key: browserKey },
      {
        onSuccess: () => {
          addNotification('Персональные данные обновлены', 'success');
          navigate('/login');
        },
        onError: (error) => {
          addNotification(getApiErrorMessage(error, 'Неверный код'), 'error');
        },
      },
    );
  };

  const handleResend = () => {
    if (!requestId) return;
    resend.mutate(
      { request_id: requestId, browser_key: browserKey },
      {
        onSuccess: () => addNotification('Новый код отправлен на почту', 'success'),
        onError: (error) => {
          addNotification(getApiErrorMessage(error, 'Не удалось отправить код'), 'error');
        },
      },
    );
  };

  if (!requestId) {
    return (
      <section className={classes.wrapper}>
        <div className={classes.card}>
          <h1 className={classes.title}>Неверная ссылка</h1>
        </div>
      </section>
    );
  }

  return (
    <section className={classes.wrapper}>
      <div className={classes.card}>
        <h1 className={classes.title}>Введите код из письма</h1>
        <p className={classes.text}>
          Мы отправили {OTP_CODE_LENGTH}-значный код. Если меняли телефон - код продиктует
          робот во входящем звонке. Код действует 2 часа.
        </p>
        <div className={classes.otpWrap}>
          <OTPInput length={OTP_CODE_LENGTH} value={code} onChange={setCode} onComplete={setCode} />
        </div>
        <div className={classes.actions}>
          <Button
            variant='filled'
            shape='brick'
            loading={verify.isPending}
            disabled={code.length < OTP_CODE_LENGTH}
            onClick={handleVerify}
          >
            Подтвердить
          </Button>
          <Button
            variant='outlined'
            shape='brick'
            loading={resend.isPending}
            onClick={handleResend}
          >
            Отправить код повторно
          </Button>
        </div>
      </div>
    </section>
  );
};
